import { render, staticRenderFns } from "./SelectAddress.vue?vue&type=template&id=d1ff5422&scoped=true&"
import script from "./SelectAddress.vue?vue&type=script&lang=js&"
export * from "./SelectAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ff5422",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1ff5422')) {
      api.createRecord('d1ff5422', component.options)
    } else {
      api.reload('d1ff5422', component.options)
    }
    module.hot.accept("./SelectAddress.vue?vue&type=template&id=d1ff5422&scoped=true&", function () {
      api.rerender('d1ff5422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Activity/components/SelectAddress.vue"
export default component.exports